import React, { useCallback, useEffect, useState } from "react";
import { Menu } from "antd";
import { connect } from "react-redux";

import TransfersEmployee from "./transfersEmployee/TransfersEmployee";
import TransfersCompany from "./transfersCompany/TransfersCompany";
import TransfersBank from "./transfersBank/TransfersBank";
import TransfersDetails from "./transfersDetails/TransfersDetails";
import { getTransfersByUsers } from "./../actions/transfers";


const Transfers = ({ getTransfers, token, userRoleId }) => {
  const [current, setCurrent] = useState("employee");

  const getStyle = menuItemKey =>
    current === menuItemKey ? "font-bold pb-6 uppercase tracking-wide" : "pb-6 uppercase tracking-wide";

  const fetchTransfers = useCallback(() => {
    getTransfers();
  }, []);

  useEffect(() => {
    fetchTransfers();
  }, []);

  const handleTransferOrderGenerated = () => {
    fetchTransfers();
    setCurrent("bank");
  };

  return (
    <div className="w-full">
      <div className="text-3xl font-bold text-gray-900 mb-12">Remboursement des NDF</div>
      <Menu onClick={e => setCurrent(e.key)} selectedKeys={[current]} mode="horizontal">
        <Menu.Item key="employee">
          <div className={getStyle("employee")}>Salarié</div>
        </Menu.Item>
        <Menu.Item key="company">
          <div className={getStyle("company")}>Entreprise</div>
        </Menu.Item>
        <Menu.Item key="bank">
          <div className={getStyle("bank")}>Banque</div>
        </Menu.Item>
        <Menu.Item key="transfers">
          <div className={getStyle("transfers")}>Virements</div>
        </Menu.Item>
      </Menu>
      <div>
        {current === "employee" && (
          <TransfersEmployee fetchTransfers={fetchTransfers} token={token} userRoleId={userRoleId} />
        )}
        {current === "company" && (
          <TransfersCompany
            handleTransferOrderGenerated={handleTransferOrderGenerated}
            token={token}
            userRoleId={userRoleId}
          />
        )}
        {current === "bank" && <TransfersBank token={token} userRoleId={userRoleId} />}
        {current === "transfers" && <TransfersDetails token={token} userRoleId={userRoleId} />}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    userRoleId: state.userInfos.role_id
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getTransfers: () => {
      dispatch(getTransfersByUsers());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Transfers);



// WEBPACK FOOTER //
// src/modules/presence/transfers/transfers.js